import { Text } from '@chakra-ui/react';
import { Redirect } from 'react-router-dom';

import { CuriousPurpleGuy, HousePurpleGuy, PointingUpPurpleGuy } from '../../assets/Images';
import { LEAccordion, LEAccordionItem } from '../../components/LEAccordion';
import LEAccordionHeader from '../../components/LEAccordion/LEAccordionHeader';
import LEAccordionContainer from '../../components/LEAccordion/LeAccordionContainer';
import { ACCORDION_NAME } from '../../components/LEAccordion/utils';
import Loader from '../../components/Loader';
import MarketplaceExplainerVideo from '../../components/marketplace/MarketplaceExplainerVideo';
import BackButton from '../../components/ui/buttons/BackButton';
import { ButtonWrapper } from '../../components/ui/buttons/ButtonWrapper';
import { getTempInfoCountryConfig } from '../../constants/countries';
import { LDFlags } from '../../constants/flags';
import { LOAN_APPLICATION } from '../../constants/urls';
import { useFlag, useStep, useTempInfo } from '../../hooks';
import { useSkipPayoffAccordion } from '../../hooks/useSkipPayoffAccordion';
import MarketplaceQuestions from '../LoanApp/components/MarketplaceQuestions';
import Residence from '../LoanApp/components/Residence';
import VerifyPersonalInfo from '../LoanApp/components/VerifyPersonalInfo';
import SellDetailsVerifyNumberItem from './components/SellDetailsVerifyNumberItem';

const SellDetails = () => {
  const marketplaceFlowPivot = useFlag(LDFlags.MARKETPLACE_FLOW_PIVOT);
  const phoneVerificationEnabled = useFlag(LDFlags.MARKETPLACE_PHONE_VERIFICATION);
  const explainerPlacement = useFlag(LDFlags.MARKETPLACE_EXPLAINER_VIDEO_PLACEMENT);
  const step = useStep();
  const skipPayoffAccordion = useSkipPayoffAccordion();
  const { info, infoLoading } = useTempInfo();

  if (infoLoading) {
    return <Loader />;
  }

  if (!getTempInfoCountryConfig(info?.data).marketplaceFlow) {
    return <Redirect to={LOAN_APPLICATION} />;
  }

  return (
    <LEAccordionContainer>
      <LEAccordionHeader>Who's selling</LEAccordionHeader>
      <Text textAlign="center" fontSize="16px" mb="5px">
        Then we'll build your listing
      </Text>
      {(explainerPlacement === 'sell_details' || explainerPlacement === 'both') && info?.id && (
        <MarketplaceExplainerVideo placement="sell_details" tempInfoId={info.id} />
      )}
      <LEAccordion name={ACCORDION_NAME.SELL_DETAILS_ACCORDION} minutes={3}>
        <LEAccordionItem
          accordionKey="sellVerifyPersonalInfo"
          title="PERSONAL INFO"
          imgSrc={PointingUpPurpleGuy}
          imgProps={{ left: '-106px', top: '-120px' }}
        >
          <VerifyPersonalInfo showWhyTooltip={false} />
        </LEAccordionItem>
        {phoneVerificationEnabled && (
          <LEAccordionItem
            accordionKey="sellVerifyNumber"
            title="VERIFY YOUR NUMBER"
            subtitle="This is how we'll text you the moment an offer comes in."
          >
            <SellDetailsVerifyNumberItem />
          </LEAccordionItem>
        )}
        <LEAccordionItem
          accordionKey="sellResidence"
          title="RESIDENTIAL INFO"
          imgSrc={HousePurpleGuy}
          imgProps={{ left: '-76px' }}
        >
          <Residence
            skipPreviousAddress
            skipPrimaryResidenceDetails
            showWhyTooltip={false}
            onComplete={!marketplaceFlowPivot ? () => step.moveNext() : undefined}
            submitLabel={!marketplaceFlowPivot ? 'BUILD MY LISTING' : undefined}
          />
        </LEAccordionItem>
        {marketplaceFlowPivot && (
          <LEAccordionItem
            accordionKey="sellMarketplaceQuestions"
            title="SELLING PREFERENCES"
            imgSrc={CuriousPurpleGuy}
            imgProps={{ left: '-76px' }}
          >
            <MarketplaceQuestions />
          </LEAccordionItem>
        )}
      </LEAccordion>
      <ButtonWrapper>
        <BackButton
          options={{
            skipPayoffAccordion,
          }}
        />
      </ButtonWrapper>
    </LEAccordionContainer>
  );
};

export default SellDetails;
